import * as React from 'react';
import { useSelector } from 'react-redux';

import { SearchSuggestIcon } from '../../../components/SearchSuggest';
import { selectSuggestionsList } from '../../../selectors/suggestions';
import { MIN_CHARS_TO_DISPLAY_SUGGEST } from '../constants';

export const useSuggestions = (value: string) => {
  const suggestionList = useSelector(selectSuggestionsList);

  return React.useMemo(() => {
    if (value.length < MIN_CHARS_TO_DISPLAY_SUGGEST) {
      return [];
    }

    return suggestionList.map(({ title, subtitle, searchUrl, imageUrl }) => ({
      title,
      subtitle,
      value: searchUrl,
      leftIcon: <SearchSuggestIcon imageUrl={imageUrl} />,
    }));
  }, [suggestionList, value]);
};
